import React, { useEffect, useRef } from 'react'

import Notifier from 'react-desktop-notification'

import NotificationAudio from './car-start.mp3'

const NotifierComponent = ({ notificationId, leadKey }) => {
    const audioElement = useRef(null)

    const notifyAboutNewLead = key => {
        Notifier.start(
            '*New Message*',
            key,
            'https://www.pulsar.ai/',
            'https://pngimg.com/uploads/alarm_clock/alarm_clock_PNG28.png'
        )

        audioElement.current.play()
    }

    useEffect(() => {
        if (!notificationId || !leadKey) {
            return
        }

        console.log('newLead', notificationId, leadKey)

        notifyAboutNewLead(leadKey)
    }, [notificationId, leadKey])

    return (
        <div>
            <audio ref={audioElement} src={NotificationAudio}></audio>
        </div>
    )
}

export default NotifierComponent
